// extracted by mini-css-extract-plugin
export var changeIcon = "_4w-4";
export var container = "_4w-0";
export var divider = "_4w-7";
export var externalLinkIcon = "_4w-1";
export var green = "_4w-5";
export var helpCircleIcon = "_4w-3";
export var iconButton = "_4w-2";
export var red = "_4w-6";